export const API_ERROR = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
};

export function handleApiError(error, clearUserCallback) {
  if (error.response && error.response.status === API_ERROR.UNAUTHORIZED) {
    // Clear user from context
    if (clearUserCallback) {
      clearUserCallback();
    }
    // Redirect to our custom login page instead of Auth0
    window.location.hash = "#/login";
    return {
      data: {
        object: null,
        Errors: [{ Description: "Session expired. Please log in again." }],
        succeeded: false,
      },
    };
  }
  if (error.response && error.response.status === API_ERROR.FORBIDDEN) {
    return {
      data: {
        object: null,
        Errors: [
          {
            Description:
              "Your user doesn't have permissions to execute this action.",
          },
        ],
        succeeded: false,
      },
    };
  }
  let message = `${error}`;
  return {
    data: {
      object: null,
      Errors: [{ Description: message }],
      succeeded: false,
    },
  };
}
